import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import {
  getApplicationProfileData,
  updateProfileEditData,
} from "../../../../reduxSlices/profileSlice";
import { isObjectEmpty, profileOptionList } from "../../../../utils/general";
import profileStyle from "../../../../components/profile/profileForms/profile.module.css";
import Aux from "../../../../hoc/Auxilliary";
import FormBuilder from "../../../FormBuilder";
import AllFormData from "./formData";
import Backdrop from "../../../Backdrop";
import SnackBar from "../../../SnackBar";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import {
  clearErrorStatusCode,
  clearErrorMessage,
  clearApplicationData,
  clearApplicantStatus,
  getInquiryData,
  getStateProvinceList,
  getApplicantStatus,
} from "../../../../reduxSlices/applicationSlice";
import localizedStrings from "../../../../utils/localize";

// Country IDs for US and Canada - State/Province field is required for these countries
const US_COUNTRY_ID = "01f93658-1116-ee11-9cbe-000d3af4f17d";
const CANADA_COUNTRY_ID = "c3f83658-1116-ee11-9cbe-000d3af4f17d";

const useStyle = makeStyles((theme) => ({
  formDesignMain: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  formContainer: {
    padding: "0.9rem 0.7rem",
    margin: "0",
    background: "#005598",
    display: "flex",
    alignItems: "center",
    color: "#fff",
  },
  formDesign: {
    width: "95%",
    margin: "0 auto",
  },
}));

var formJson = {};

const ProfileDesign = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [FormData, setFormData] = useState(AllFormData);
  const profileData = useSelector(
    (state) => state.profileData.applicationProfileData,
  );
  const [primaryDetails, setPrimaryDetails] = useState(FormData.primaryDetails);
  const [contact, setContact] = useState(FormData.contact);
  const [HomeAddress, setHomeAddress] = useState(FormData.HomeAddress);
  const [displayMessage, setDisplayMessage] = useState("");
  for (let key in primaryDetails) {
    formJson[key] = primaryDetails[key].value;
  }
  for (let key in contact) {
    formJson[key] = contact[key].value;
  }

  for (let key in HomeAddress) {
    formJson[key] = HomeAddress[key].value;
  }

  const dataFetchingStatus = useSelector(
    (state) => state.profileData.dataFetchingStatus,
  );

  const errorMessage = useSelector((state) => state.profileData.errorMessage);

  const errorStatusCode = useSelector(
    (state) => state.profileData.errorStatusCode,
  );

  const inquiry = useSelector((state) => state.applicationData.inquiry);

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const stateProvinceList = useSelector(
    (state) => state.applicationData.stateProvinceList,
  );

  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(getInquiryData());
    dispatch(getStateProvinceList("contact", "ses_stateorprovince"));
  }, [dispatch]);

  useEffect(() => {
    if (!isObjectEmpty(applicantStatus.ses_applicantstatus)) {
      dispatch(
        getApplicationProfileData(
          applicantStatus.ses_applicantstatus.ses_applicantid,
        ),
      );
    }
  }, [applicantStatus]);

  useEffect(() => {
    const newFormData = { ...FormData };
    for (const key in props.fields) {
      const item = props.fields[key];
      for (const field in item) {
        if (newFormData[key] && newFormData[key][field]) {
          if (item[field].hasOwnProperty("disabled")) {
            newFormData[key][field].elementConfig.disabled =
              item[field].disabled;
          }
          if (item[field].hasOwnProperty("required")) {
            newFormData[key][field].elementConfig.required =
              item[field].required;
          }
        }
      }
    }
    setFormData({ ...FormData, ...newFormData });
  }, [props.title]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearApplicationData());
    dispatch(clearApplicantStatus());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let status = { ...showSnackBar };
        status.status = true;
        status.message = `${localizedStrings.general.sessionexpired}`;
        setShowSnackBar(status);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let status = { ...showSnackBar };
        status.status = true;
        status.message = errorMessage;
        setShowSnackBar(status);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    const newHomeAddress = { ...HomeAddress };

    if (inquiry.countries && inquiry.countries?.length > 0) {
      const countries = inquiry.countries.map((country) => ({
        value: country.ses_countrynameid,
        displayValue: country.ses_countryname,
      }));
      newHomeAddress._ses_countryofresidence_value.elementConfig.options =
        countries;
    }
    setHomeAddress(newHomeAddress);
  }, [inquiry]);

  const [jsonData, setJsonData] = useState(formJson);

  const textFieldChangeHandler = (event) => {
    const formJsonCopy = { ...jsonData };
    formJsonCopy[event.target.name] = event.target.value;
    setJsonData(formJsonCopy);
    dispatch(updateProfileEditData(formJsonCopy));
  };

  useEffect(() => {
    if (!isObjectEmpty(profileData)) {
      const newProfile = { ...profileData };
      newProfile.birthdate = new moment(newProfile.birthdate).format(
        "YYYY-MM-DD",
      );
      if (newProfile.home2 === undefined && newProfile.telephone1) {
        newProfile.home2 = newProfile.telephone1;
      }

      setJsonData(newProfile);

      dispatch(updateProfileEditData(newProfile));
    }
  }, [profileData, dispatch]);

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
  };

  const handleChange = (event, eventName) => {
    const formJsonCopy = { ...jsonData };
    formJsonCopy[eventName] = event.target.value;
    setJsonData(formJsonCopy);
    dispatch(updateProfileEditData(formJsonCopy));
  };

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    const newPrimaryDetails = { ...primaryDetails };
    newPrimaryDetails.birthdate.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.birthdate;
    newPrimaryDetails.emailaddress1.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.emailaddress1;
    newPrimaryDetails.applicantId.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.applicantId;
    newPrimaryDetails.firstname.elementConfig.label =
      localizedStrings.application.personalInformation.firstName;
    newPrimaryDetails.ses_preferredname.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.preferredname;
    newPrimaryDetails.middlename.elementConfig.label =
      localizedStrings.application.personalInformation.middleName;
    newPrimaryDetails.lastname.elementConfig.label =
      localizedStrings.application.personalInformation.lastName;
    newPrimaryDetails.gendercode.elementConfig.label =
      localizedStrings.students.profile.primaryDetails.gender;

    newPrimaryDetails.gendercode.elementConfig.options =
      newPrimaryDetails.gendercode.elementConfig.options.map((option) => {
        if (option.value === 1) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.male,
          };
        } else if (option.value === 2) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.female,
          };
        } else if (option.value === 943240003) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.nonbinary,
          };
        } else if (option.value === 943240010) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.termransgender,
          };
        } else if (option.value === 943240005) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.twospirit,
          };
        } else if (option.value === 943240011) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.genderother,
          };
        } else if (option.value === 943240009) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.iprefernottoanswer,
          };
        }
        return option;
      });

    setPrimaryDetails(newPrimaryDetails);
    const newContact = { ...contact };
    newContact.mobilephone.elementConfig.label =
      localizedStrings.students.profile.contact.mobilePhone;
    newContact.home2.elementConfig.label =
      localizedStrings.students.profile.contact.telephone2;
    newContact.business2.elementConfig.label =
      localizedStrings.students.profile.contact.business2;
    newContact.ses_optinfortextmessages.elementConfig.aboveText =
      localizedStrings.students.profile.contact.optinfortextmessages;
    newContact.ses_optinfortextmessages.elementConfig.options =
      newContact.ses_optinfortextmessages.elementConfig.options.map(
        (option) => {
          if (option.value === true) {
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.yes,
            };
          } else if (option.value === false) {
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.no,
            };
          }
          return option;
        },
      );
    setContact(newContact);
    const newHomeAddress = { ...HomeAddress };
    newHomeAddress.address1_city.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_city;
    newHomeAddress._ses_countryofresidence_value.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_country;
    newHomeAddress.address1_line1.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_line1;
    newHomeAddress.address1_postalcode.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.prospective_address1_postalcode;
    newHomeAddress.ses_stateorprovince.elementConfig.label =
      localizedStrings.students.profile.HomeAddress.address1_stateorprovince;
    setHomeAddress(newHomeAddress);
    setFormData((prev) => ({
      ...prev,
      primaryDetails: newPrimaryDetails,
      contact: newContact,
      HomeAddress: newHomeAddress,
    }));
  }, [language]);

  useEffect(() => {
    const newContact = { ...contact };
    newContact.ses_optinfortextmessages.elementConfig.display =
      jsonData.mobilephone !== null &&
      jsonData.mobilephone !== "" &&
      jsonData.mobilephone !== undefined
        ? "block"
        : "none";
    setContact(newContact);
    setFormData((prev) => ({ ...prev, contact: newContact }));
  }, [jsonData.mobilephone]);

  useEffect(() => {
    if (stateProvinceList && stateProvinceList?.length > 0) {
      const desiredOrder = [
        "AB",
        "BC",
        "MB",
        "NB",
        "NL",
        "NS",
        "NT",
        "NU",
        "ON",
        "PE",
        "QC",
        "SK",
        "YT",
        "AL",
        "AK",
        "AR",
        "AZ",
        "CA",
        "CO",
        "CT",
        "DC",
        "DE",
        "FL",
        "GA",
        "HI",
        "IA",
        "ID",
        "IL",
        "IN",
        "KS",
        "KY",
        "LA",
        "MA",
        "MD",
        "ME",
        "MI",
        "MN",
        "MO",
        "MS",
        "MT",
        "NC",
        "ND",
        "NE",
        "NH",
        "NJ",
        "NV",
        "NM",
        "NY",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WI",
        "WV",
        "WY",
        "AS",
        "FM",
        "GU",
        "MH",
        "MP",
        "PR",
        "PW",
        "VI",
        "AA",
        "AE",
        "AP",
        "Other",
      ];

      const stateOptions = stateProvinceList
        .map((pro) => ({
          displayValue: pro.value,
          value: pro.attributevalue,
        }))
        .sort((a, b) => {
          const aCode = (a.displayValue || "").toUpperCase();
          const bCode = (b.displayValue || "").toUpperCase();
          const aIdx = desiredOrder.indexOf(aCode);
          const bIdx = desiredOrder.indexOf(bCode);
          const normAIdx = aIdx === -1 ? Number.MAX_SAFE_INTEGER : aIdx;
          const normBIdx = bIdx === -1 ? Number.MAX_SAFE_INTEGER : bIdx;
          if (normAIdx !== normBIdx) return normAIdx - normBIdx;
          return aCode.localeCompare(bCode, "en", {
            sensitivity: "base",
            numeric: true,
          });
        });

      const newHomeAddress = { ...HomeAddress };
      newHomeAddress.ses_stateorprovince.elementConfig.options = stateOptions;
      setHomeAddress(newHomeAddress);
      setFormData((prev) => ({ ...prev, HomeAddress: newHomeAddress }));
    }
  }, [stateProvinceList]);

  // Show and require State/Province and Postal Code only for US or Canada
  useEffect(() => {
    const countryId = jsonData?._ses_countryofresidence_value;
    const isUSorCanada =
      countryId === US_COUNTRY_ID || countryId === CANADA_COUNTRY_ID;

    const newHomeAddress = { ...HomeAddress };

    newHomeAddress.ses_stateorprovince = {
      ...newHomeAddress.ses_stateorprovince,
     
      elementConfig: {
        ...newHomeAddress.ses_stateorprovince.elementConfig,
        required: isUSorCanada,
         display: isUSorCanada ? "block" : "none",
      },
      value: isUSorCanada ? newHomeAddress.ses_stateorprovince.value : "",
    };

    newHomeAddress.address1_postalcode = {
      ...newHomeAddress.address1_postalcode,
      display: isUSorCanada ? "block" : "none",
      elementConfig: {
        ...newHomeAddress.address1_postalcode.elementConfig,
        required: isUSorCanada,
      },
      value: isUSorCanada ? newHomeAddress.address1_postalcode.value : "",
    };

    setHomeAddress(newHomeAddress);
  }, [jsonData?._ses_countryofresidence_value]);

  useEffect(() => {
    if (showSnackBar.message === "Data Updated") {
      setDisplayMessage(localizedStrings.general.dataupdatedMessage);
    } else if (showSnackBar.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (
      showSnackBar.message === "Invalid token or you are missing header token"
    ) {
      setDisplayMessage(localizedStrings.general.invalidTokenandheader);
    } else if (showSnackBar.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(showSnackBar.message);
    }
  }, [showSnackBar]);

  return (
    <Aux>
      <Backdrop show={dataFetchingStatus} />
      <SnackBar
        open={showSnackBar.status}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Grid container item className={classes.formDesignMain}>
        <Grid
          direction="column"
          container
          item
          className={`${profileStyle.mainConatiner} ${profileStyle.conatinerWidth}`}
          style={{ alignSelf: "flex-start" }}
        >
          <Typography component="div" className={classes.formContainer}>
            {localizedStrings.students.profile.primaryDetails.primaryDetails}
          </Typography>
          <div className={classes.formDesign}>
            <FormBuilder
              formDetails={FormData.primaryDetails}
              value={jsonData}
              changed={(event) => textFieldChangeHandler(event)}
              handleChange={handleChange}
            />
          </div>
        </Grid>
        <Grid
          className={profileStyle.conatinerWidth}
          direction="column"
          container
        >
          <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
              {localizedStrings.students.profile.contact.contact}
            </Typography>
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={FormData.contact}
                value={jsonData}
                changed={(event) => textFieldChangeHandler(event)}
                handleChange={handleChange}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          className={profileStyle.conatinerWidth}
          container
          direction="column"
        >
          <Grid
            direction="column"
            container
            item
            className={profileStyle.mainConatiner}
          >
            <Typography component="div" className={classes.formContainer}>
              {localizedStrings.students.profile.HomeAddress.HomeAddress}
            </Typography>
             <div className={classes.formDesign}>
               <FormBuilder
                 formDetails={HomeAddress}
                 value={jsonData}
                 changed={(event) => textFieldChangeHandler(event)}
                 handleChange={handleChange}
               />
             </div>
          </Grid>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default withRouter(ProfileDesign);
